import { useState } from "react";
import { Box, Button, TextField, ThemeProvider, createTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";
import swal from "sweetalert";

let theme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#1A8D90',
    },
  },
});

const Form = ({callBackAfterSubmit,formData}) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cookie,setCookie] = useCookies(['token'])
  const [document,setDocument] = useState(null)
  const [data,setData] = useState({
    name: formData?formData["name"]:"",
    code: formData?formData["code"]:""
  })
  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(data["name"].trim()===""){
      swal("Error","Please Enter a Valid Name",'error')
      return
    }
    if(data["code"].trim()===""){
      swal("Error","Please Enter a Valid Code",'error')
      return
    }
    const form = new FormData()
    form.append("document",formData?"null":document)
    form.append("id",formData?formData['id']:"null")
    form.append("name",data["name"])
    form.append("code",data["code"])
    fetch(process.env.REACT_APP_BACKEND_URL+"/company/add",{method:"POST",headers:{
      Authorization:"Bearer "+cookie['token'],
    },body:form,}).then(async(resp)=>{
      const json = await resp.json()
      if("error" in json){
        swal("Error",json['message'],'error')
        return
      }
      callBackAfterSubmit()
    }).catch((e)=>{
      setCookie("token",null)
    })
  };

  const handleChange = (e)=>{
    setData(prev=>({...prev, [e.target.name]:e.target.value}))
  }

  return (
    <AuthGuard>
    <Box m="20px" mt={"5rem"} sx={{background:"white",width: "90%",
          maxWidth: "800px",boxSizing:"border-box",px:"1rem",zIndex:999,margin:"0 auto",borderRadius:"15px"}}>
    <Header title={formData?"Update Company":"CREATE COMPANY"} subtitle={formData?"Update Company Profile":"Create a New Company Profile"} />
    <ThemeProvider theme={theme}>
    <form onSubmit={handleFormSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                  pt:"3rem"
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Company Name"
                  onChange={handleChange}
                  value={data['name']}
                  name="name"
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Code"
                  onChange={handleChange}
                  value={data['code']}
                  name="code"
                  sx={{ gridColumn: "span 2" }}
                />
                <Button variant="contained" component="label" onChange={(e)=>setDocument(e.target.files[0])}>
                  Upload Document
                  <input
                  type="file"
                  hidden
                  />
                </Button>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  {formData?"Update Company":"Create New Company"}
                </Button>
              </Box>
            </form>
</ThemeProvider>
          </Box>
    </AuthGuard>
  );
};

export default Form;
